import React, { useState } from 'react';
import { LabeledSectionSelectBox } from './LabeledSectionSelectBox';
import { MarketComparisonChart } from './MarketComparisonChart';
import { ManufacturerMultiSelect } from './ManufacturerMultiSelect';
import { MarketComparisonTable } from './MarketComparisonTable';
import './styles.css';
import { PLACEHOLDER_MANUFACTURER } from './constants';
import { LabeledSelectBox } from './LabeledSelectBox';
import { CollapsibleTableContainer } from './CollapsibleTableContainer';

export const MarketComparison = ({
    isLoading,
    rawData,
    manufacturerId,
    sections,
    sectionNumber,
    handleSectionChanged,
    startYear,
    handleStartYearChanged
}) => {
    const [selectedManufacturerIds, setSelectedManufacturerIds] = useState([]);
    if (isLoading) {
        return <p>Loading manufacturer data...</p>;
    }

    if (!manufacturerId || manufacturerId === PLACEHOLDER_MANUFACTURER) {
        return <p>Please select a manufacturer.</p>;
    }

    // Select current manufacturer by default
    const manufacturers = getManufacturers(rawData);
    if (manufacturerId && !selectedManufacturerIds.length) {
        selectedManufacturerIds.push(manufacturerId);
    }

    const section = sections
        ? sections.find(s => s.number === sectionNumber)
        : null;

    const years = rawData
        ? Array.from(
            new Set(rawData.map(d => parseInt(d.year))))
            .sort()
        : [];
    const startYearInt = parseInt(startYear);
    let chartData = rawData;
    if (startYearInt && rawData && years.includes(startYearInt)) {
        chartData = chartData.filter(d => d.year >= startYearInt);
    }

    var mfgIdsSet = new Set(selectedManufacturerIds.map(mfId => parseInt(mfId)));
    const tableData = chartData
        ? chartData.filter(d => mfgIdsSet.has(d.manufacturerId))
        : null;

    return (
        <div>
            <LabeledSectionSelectBox selectedSectionNumber={sectionNumber} sections={sections} onSectionChanged={handleSectionChanged} />
            <ManufacturerMultiSelect
                defaultManufacturerId={manufacturerId.toString()}
                manufacturers={manufacturers}
                handleManufacturersChanged={(manufacturers) => {
                    const mfgIds = manufacturers ? manufacturers.map(m => m.id) : []
                    setSelectedManufacturerIds(mfgIds);
                }} />
            <LabeledSelectBox
                label="Starting Year"
                items={years}
                selectedValue={startYearInt}
                onSelectionChanged={handleStartYearChanged} />
            <MarketComparisonChart section={section} rawData={chartData} manufacturerIds={selectedManufacturerIds} />
            {rawData
                ? <CollapsibleTableContainer>
                    <MarketComparisonTable rawData={tableData} />
                </CollapsibleTableContainer>
                : null
            }
        </div >
    );
}

function getManufacturers(rawData) {
    if (!rawData) {
        return null;
    }

    const manufacturerSet = new Set(rawData.map(d => `${d.manufacturerName}::${d.manufacturerId}`));
    return Array.from(manufacturerSet)
        .sort()
        .map(s => {
            const parts = s.split('::');
            return {
                name: parts[0],
                id: parts[1]
            };
        });
}